import * as React from 'react';
import { Redirect, RouteComponentProps } from 'react-router';
import { RouteDefinitions } from '@common/route-definitions';

export interface AuthRedirectComponentProperties extends RouteComponentProps<{}> {
  readonly isLoggedIn: boolean;
}

// Page definition
export class AuthRedirectComponent extends React.Component<AuthRedirectComponentProperties> {
  checkLoggedIn() {
    const location = this.props.location || (this.props.history || {}).location;
    if (
      this.props.isLoggedIn ||
      location.pathname === RouteDefinitions.login ||
      location.pathname === RouteDefinitions.autoautho ||
      location.pathname === RouteDefinitions.tutorial.AutoAuthoTutorial ||
      location.pathname === RouteDefinitions.tutorial.SWOStatusTutorial ||
      location.pathname === RouteDefinitions.cilNotification.Notification
    ) {
      return;
    }
    return <Redirect push={true} to={RouteDefinitions.login} />;
  }

  render() {
    return <div>{this.checkLoggedIn()}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/auth/_components/auth-redirect.component.tsx